import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var LanguageTranslationService = /** @class */ (function () {
    function LanguageTranslationService(httpObj) {
        this.httpObj = httpObj;
        this.lang_data = {};
    }
    LanguageTranslationService.prototype.useLang = function (lang, country) {
        var _this = this;
        return new Promise(function (resolve, _reject) {
            var languageCountry = lang.toLowerCase() + '-' + country.toUpperCase();
            var langFilePath = "assets/lang/" + (languageCountry || 'en-NL') + ".json";
            _this.httpObj.get(langFilePath).subscribe(function (translationData) {
                _this.lang_data = Object.assign({}, translationData || {});
                resolve(_this.lang_data);
            }, function (error) {
                resolve(_this.lang_data);
                console.log(error);
            });
        });
    };
    LanguageTranslationService.ngInjectableDef = i0.defineInjectable({ factory: function LanguageTranslationService_Factory() { return new LanguageTranslationService(i0.inject(i1.HttpClient)); }, token: LanguageTranslationService, providedIn: "root" });
    return LanguageTranslationService;
}());
export { LanguageTranslationService };
